import React from 'react'
import Box from 'transfix-ui/core/Box'
import {
  GetNormFileGeneratorStatusesQueryParams,
  NormFileGeneratorStatus,
} from 'apps/marketplace/apiTypes/normFileGeneratorStatuses'
import { Pagination, Spinner } from 'transfix-ui'
import { NormingJobsTable } from './NormingJobsTable'

const PER_PAGE = 20

interface INormingJobsPollingTableProps {
  loading: boolean
  displayNorms: NormFileGeneratorStatus[]
  requestParams: GetNormFileGeneratorStatusesQueryParams
  totalCount: number
  setRequestParams: (value: React.SetStateAction<GetNormFileGeneratorStatusesQueryParams>) => void
}

export const NormingJobsPollingTable = ({
  displayNorms,
  loading,
  requestParams,
  setRequestParams,
  totalCount,
}: INormingJobsPollingTableProps) => {
  const pageChangeHandler = (newPageNumber: number) =>
    setRequestParams({
      ...requestParams,
      pageCount: newPageNumber - 1,
    })

  return (
    <>
      {loading && <Spinner key='norming-loading-spinner' position='absolute' />}
      {!loading && (
        <Box key='norming-tab'>
          <Box mb={2}>
            <NormingJobsTable normingJobs={displayNorms} />
          </Box>
          <Box textAlign='center'>
            <Pagination
              currentPage={(requestParams.pageCount || 0) + 1}
              numberOfPages={Math.ceil(totalCount / PER_PAGE)}
              onPageChange={pageChangeHandler}
            />
          </Box>
        </Box>
      )}
    </>
  )
}
